import js from "../../src/assets/images/skillIcons/JS.png";
import ts from "../../src/assets/images/skillIcons/typescript.png";
import react from "../../src/assets/images/skillIcons/react_logo.png";
import html from "../../src/assets/images/skillIcons/html.png";
import css from "../../src/assets/images/skillIcons/css.png";
import git from "../../src/assets/images/skillIcons/Git.png";
import materialUi from "../../src/assets/images/skillIcons/material-ui.png";
import redux from "../../src/assets/images/skillIcons/redux.png";
import postman from "../../src/assets/images/skillIcons/postman.png";
import vue from "../../src/assets/images/skillIcons/vue.png";
import tailwind from "../../src/assets/images/skillIcons/tailwind.png";
import bootstrap from "../../src/assets/images/skillIcons/bootstrap.png";
import nuxt from "../../src/assets/images/skillIcons/nuxt-logo.png";
import next from "../../src/assets/images/skillIcons/nextjs-logo.png";
import { title } from "process";

export const skills = [
	{
		title: 'JAVASCRIPT',
		img: js
	},
	{
		title: 'TYPESCRIPT',
		img: ts
	},
	{
		title: 'REACT',
		img: react
	},
	{
		title: 'REDUX/REDUX TOOLKIT',
		img: redux
	},
    {
        title: 'REACT NATIVE',
        img: react,
    },
	{
		title: 'VUE/VUEX',
		img: vue
	},
	{
		title: 'NUXT',
		img: nuxt
	},
	{
		title: 'NEXT',
		img: next
	},
	{
		title: 'HTML',
		img: html
	},
	{
		title: 'CSS/SASS',
		img: css
	},
	{
		title: 'TAILWIND',
		img: tailwind
	},
	{
		title: 'BOOTSTRAP',
		img: bootstrap
	},
	{
		title: 'GIT',
		img: git
	},
	{
		title: 'MATERIAL UI',
		img: materialUi
	},
	{
		title: 'POSTMAN',
		img: postman
	}
]